import { useSetting } from "@faire/marketplace-lib/settings/__internal__/useSetting";
import { HOLIDAY_SPEND_CHALLENGE_SIGN_UP_END_DATE } from "@faire/web-api--source/indigofair/settings/HOLIDAY_SPEND_CHALLENGE_SIGN_UP_END_DATE";

export const useSettingHolidaySpendChallengeSignUpEndDate = (): string =>
  useSetting(
    HOLIDAY_SPEND_CHALLENGE_SIGN_UP_END_DATE,
    "2025-10-15T00:00:00.000-04:00"
  );
